// 在查看画布捕获阶段转交滚轮：标题和边缘区域也属于同一个列表。
// 不接管 Ctrl/Shift 或横向手势，保留浏览器缩放及画布横向滚动。
export function scrollFleetList (event, layer) {
  if (event.defaultPrevented || event.cancelable === false || event.ctrlKey || event.shiftKey ||
      !Number.isFinite(event.deltaY) || !event.deltaY || Math.abs(event.deltaX || 0) > Math.abs(event.deltaY)) return false
  const root = layer && layer.querySelector('.screen-fleet-list')
  const body = root && root.querySelector('.screen-fleet-list__scroll')
  if (!body) return false
  const rect = root.getBoundingClientRect()
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) return false
  const max = body.scrollHeight - body.clientHeight
  if (max <= 0) return false
  const style = body.ownerDocument.defaultView.getComputedStyle(body)
  const line = parseFloat(style.lineHeight) || (parseFloat(style.fontSize) || 16) * 1.2
  const unit = event.deltaMode === 1 ? line : event.deltaMode === 2 ? body.clientHeight : 1
  // 到顶/到底仍取消原生滚动，避免把滚轮传到外层大屏。
  event.preventDefault()
  body.scrollTop = Math.max(0, Math.min(max, body.scrollTop + event.deltaY * unit))
  return true
}
